"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_masonry_component_1 = require("react-masonry-component");
const PortfolioModal_1 = require("./partial/PortfolioModal");
const ExtraStore_1 = require("../stores/ExtraStore");
const fluxible_addons_react_1 = require("fluxible-addons-react");
class Portfolio extends React.Component {
    constructor(props) {
        super(props);
        this.openModal = (e, work) => {
            e.preventDefault();
            this.setState({ modalIsOpen: true, work });
        };
        this.closeModal = (e) => {
            e.preventDefault();
            this.setState({ modalIsOpen: false, work: null });
        };
        this.state = {
            modalIsOpen: false,
        };
    }
    render() {
        const works = this.props.works;
        return (React.createElement("section", { className: "pt-page pt-page-3 pt-page-current", id: "portfolios" },
            this.state.work
                && React.createElement(PortfolioModal_1.default, { portfolio: this.state.work, modalIsOpen: this.state.modalIsOpen, closeModal: this.closeModal }),
            React.createElement("div", { className: "section-title-block" },
                React.createElement("h2", { className: "section-title" }, "Portfolio"),
                React.createElement("h5", { className: "section-description" }, "My Best Works")),
            React.createElement("div", { className: "portfolio-content" },
                React.createElement("div", { id: "portfolio_grid", className: "portfolio-grid portfolio-masonry masonry-grid-3 shuffle", style: {
                        position: 'relative',
                        overflow: 'hidden',
                        height: '854.652px',
                        transition: 'height 450ms ease-out 0s'
                    } },
                    React.createElement(react_masonry_component_1.default, null, works.map((work) => {
                        return (React.createElement("figure", { key: work._id, className: "item shuffle-item filtered" },
                            React.createElement("a", { onClick: (e) => {
                                    this.openModal(e, work);
                                }, className: "ajax-page-load", href: "#" },
                                work.heroImage
                                    && React.createElement("img", { src: work.heroImage.secure_url, alt: '12' }),
                                React.createElement("div", null,
                                    React.createElement("h5", { className: "name" }, work.title),
                                    React.createElement("small", null, work.category),
                                    React.createElement("i", { className: "fa fa-file-text-o" })))));
                    }))))));
    }
}
exports.default = (0, fluxible_addons_react_1.connectToStores)(Portfolio, [ExtraStore_1.default], (context, props) => {
    return {
        works: (context.getStore(ExtraStore_1.default)).getWorks(),
    };
});
